/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EquipmentStates {

    Free = 'Free',

    InRepair = 'InRepair',

    UnknownWorker = 'UnknownWorker',

    Offline = 'Offline',

    Defect = 'Defect',

    HighTemperature = 'HighTemperature',

    HashrateAbove98 = 'HashrateAbove98',

    HashrateAbove80 = 'HashrateAbove80',

    HashrateAbove1 = 'HashrateAbove1',

    NoHashrate = 'NoHashrate',

    Online = 'Online',

    Unavailable = 'Unavailable'
}

